import { useFirestoreUpdate } from 'global/cnr/contexts/useHelpers/useFirestoreUpdate'
import { useModifyProps } from 'global/cnr/contexts/useHelpers/useModifyProps'
import { updateLinkHelpers } from 'global/firestoreData/updates/subUpdates/fsUpdate_dataLInks'
import _ from 'lodash'
import { useContext, useEffect, useMemo, useState } from 'react'
import { Icon } from 'semantic-ui-react'
import { FrameworkContext } from '../../cnr/contexts/FrameworkContent'
import { ParentContext } from '../../cnr/contexts/ParentContext'
import { frameworkRightTypes } from '../../cnr/reducers/FrameworkReducer'
import { convertHelpers } from '../../common/convert'
import UiSaveButtons from '../../components/buttons/UiSaveButtons'
import DropdownOptionsMenu from '../../components/forms/elements/DropdownOptionsMenu'
import { appIconTypes } from '../../enums/appIconTypes'
import { gEnums } from '../../enums/globalEnums'
import { iconColorTypes } from '../../enums/settingsIconTypes'
import { createRefPath_event } from '../../firestoreData/appData/appRefPaths'
import DataItemModifyForm from '../../pageItem/modification/dataModifications/DataItemModifyForm'
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper'
import { dataModificationTypes } from '../enums/itemActionTypes'
import { openExternal } from '../helpers/settingsLinks'
import DataLinkingSidebar from './DataLinkingSidebar'

const _optionsTypes = {
  deleteItem: 'deleteItem',
  linkData: 'linkData',
  openDatabase: 'openDatabase',
}

const ItemModifySidebar = (props) => {

  const {
    addMode,
    collectionName,
    getTheData,
    handleBack,
    itemData,
    selectedEditItemKey,
    singleDataItem,
    viewItem,
  } = props ?? {}


  const _isNewItem = _.isEmpty(itemData)
  const selectedName = convertHelpers.getItemName(!addMode ? itemData : {})

  const { props: props_viewItem, key: key_viewItem } = viewItem ?? {}

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { appUser_state, eventInfo_state, paps_state, currentSettings_state } = states ?? {}
  const { page_fns, database_fns, navigation_fns } = fns ?? {}
  const { pathViews, view } = paps_state ?? {}
  const { aps_global, aps_viewItems, aps_views, aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appDataSource, dataPermissions, dataRestrictions } = aps_global ?? {}
  const { restrictArrayEdits } = dataPermissions ?? {}
  const { appDataDocuments } = eventInfo_state ?? {}

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_handlers, framework_state } = frameworkContext ?? {}
  const { frInfo, frameworkRightType, dataModifyType } = framework_state ?? {}
  const { uivi } = frInfo ?? {}

  let _dataModifyType = _isNewItem ? dataModificationTypes.add : dataModifyType
  if (!_dataModifyType) { _dataModifyType = dataModificationTypes.edit }

  const dataUpdateType = useMemo(() => {
    let _dataUpdateType;

    if (frameworkRightType) {
      switch (frameworkRightType) {
        case frameworkRightTypes.pageDataAdd:
          _dataUpdateType = gEnums.dataUpdateTypes.addData
          break;

        case frameworkRightTypes.pageDataEdit:
          _dataUpdateType = gEnums.dataUpdateTypes.updateDoc
          break;
      }
    }

    if (_dataModifyType) {
      switch (_dataModifyType) {
        case dataModificationTypes.add:
          _dataUpdateType = gEnums.dataUpdateTypes.addData
          break;

        case dataModificationTypes.edit:
          _dataUpdateType = gEnums.dataUpdateTypes.updateDoc
          break;
      }
    }
    return _dataUpdateType
  }, [])

  const { updateFsData } = useFirestoreUpdate({ dataUpdateType })

  const [modifyData_original, setModifyData_original] = useState()
  const [modifyData, setModifyData] = useState()
  const [currentViewItem, setCurrentViewItem] = useState(viewItem)
  const [updating, setUpdating] = useState()
  const [showConfirmation, setShowConfirmation] = useState()

  const modifyProps = useModifyProps({ viewItem, dataModificationType: dataModificationTypes.edit, itemData: { [itemData?._itemKey]: itemData } })

  const handle_showConfirmation = (opts) => {
    const { optionType } = opts
    setShowConfirmation(showConfirmation === optionType ? null : optionType)
  }

  const handleOpenDb = () => {
    if (currentViewItem && modifyData) {
      const { key } = currentViewItem
      const { _itemKey } = modifyData
      openExternal.db(pathViews, null, [key, _itemKey])
    }
  }

  const updateDatabase = (dataUpdateType, data, data_original) => {

    const cb = (d) => {
      setUpdating(false)
      handleBack && handleBack()
      framework_handlers && framework_handlers.handleShow_frameworkRight()
    }

    // setUpdating(true)

    const ufProps = {
      dataUpdateType,
      allInfo: data,
      itemData: data,
      itemData_original: data_original,
      vit: viewItem ? viewItem.key : null,
      view: view,
      appDataSource,
    }

    const _appDataDocuments = _.cloneDeep(appDataDocuments)
    const appDataDocument = _appDataDocuments?.[ufProps.vit]
    const { _itemKey } = data ?? {}
    const _appDataDoc = { ...appDataDocument?.[_itemKey], ...data }
    _appDataDocuments[ufProps.vit][_itemKey] = _appDataDoc

    const appDataDocs = updateLinkHelpers.autoSyncBidirectional(_appDataDocuments)
    updateFsData({ data_modified: data, data_original, vit: viewItem?.key, callback: cb, appDataDocs })

  }

  const handleDelete = () => updateDatabase(gEnums.dataUpdateTypes.deleteCollectionItems, itemData)

  const handleSave = () => {

    let dataUpdateType;

    if (frameworkRightType) {
      switch (frameworkRightType) {
        case frameworkRightTypes.pageDataAdd:
          dataUpdateType = gEnums.dataUpdateTypes.addData
          break;

        case frameworkRightTypes.pageDataEdit:
          dataUpdateType = gEnums.dataUpdateTypes.updateDoc
          break;
      }
    }

    if (_dataModifyType) {
      switch (_dataModifyType) {
        case dataModificationTypes.add:
          dataUpdateType = gEnums.dataUpdateTypes.addData
          break;

        case dataModificationTypes.edit:
          dataUpdateType = gEnums.dataUpdateTypes.updateDoc
          break;
      }
    }

    updateDatabase(dataUpdateType, modifyData, modifyData_original)

  }

  const ammendCurrentData = (dataKey) => {
    const _data = singleDataItem ? itemData : itemData ? itemData[dataKey] : itemData
    setModifyData(_data)
  }

  const x = (key) => {
    return {
      data: {
        formItemType: gEnums.formItemTypes.select,
        listType: 'statusTypes'
      },
      propSection: key,
      key: key,
      display: {
        caption: _.startCase(key),
        elemPropType: gEnums.elemPropTypes.normal
      },
      ui: {
        caption: _.startCase(key),
      },
      show: true,
      position: 10,
    }
  }


  useEffect(() => {
    if (key_viewItem) {
      setCurrentViewItem(viewItem)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [key_viewItem]);

  useEffect(
    () => {
      framework_handlers.handleAmmend_frameworkLeft({ modifyData, currentViewItem }, 'uiModifySidebar')
      // eslint-disable-next-line react-hooks/exhaustive-deps  
    }, [key_viewItem, modifyData]
  )

  useEffect(() => {
    if (getTheData) {
      const cb = (data) => {
        setModifyData(data)
        setModifyData_original(data)
      }
      const _refPath = createRefPath_event(pathViews, [collectionName, selectedEditItemKey])
      database_fns.get_doc({ refPath: _refPath, callback: cb })
    } else {
      switch (frameworkRightType) {
        case frameworkRightTypes.dataModification:
          setModifyData({})
        case frameworkRightTypes.pageDataEdit:
          ammendCurrentData(selectedEditItemKey)
          break;
        case frameworkRightTypes.pageDataAdd:
          setModifyData({})
          break;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [selectedEditItemKey]);

  const updateLocal = (d) => setModifyData(d)

  const modifyHandlers = () => {
    return {
      handleFormDataChange_local: (d) => updateLocal(d),
    }
  }

  const ddOptions = () => {
    let _icon = 'save'
    let _allowOpen = false;
    let _allowDelete = false;
    let oc = handle_showConfirmation
    switch (_dataModifyType) {
      case dataModificationTypes.add:
        _allowOpen = false
        break;
      case dataModificationTypes.edit:
        _allowDelete = true
        break;
      default:
        break;
    }
    const btns = []
    _.forEach(_optionsTypes, (optionType) => {
      let allowItem = true
      switch (optionType) {
        case _optionsTypes.deleteItem:
          allowItem = _allowDelete
          _icon = 'delete'
          break;
        case _optionsTypes.linkData:
          _icon = 'linkify'
          break;
        case _optionsTypes.openDatabase:
          _icon = 'external alternate'
          oc = handleOpenDb
          break;
        default:
        // nothing 
      }
      if (allowItem) {
        btns.push({ caption: _.startCase(optionType), oc: oc, icon: _icon, fl: true, opts: { optionType: optionType } })
      }
    })
    return <DropdownOptionsMenu
      menuButtons={btns}
      caption={'Actions'}
      color={'blue'}
      icon={'content'}
      float={'left'}
    />
  }

  const footer_modify = () => {
    let caption = 'Save'
    switch (_dataModifyType) {
      case dataModificationTypes.add:
        caption = 'Add Item (ims)'
        break;
      case dataModificationTypes.edit:
        caption = 'Update Item (ims)'
        break;
      default:
        caption = 'Update Item'
        break;
    }
    const btns = []
    btns.push({ oc: handleSave, caption, icon: 'save' })
    return <UiSaveButtons others={btns} dropdowns={ddOptions()} />
  }

  const footer_confirmation = () => {
    const btns = []
    btns.push({ oc: handleDelete, caption: 'Delete Item', icon: appIconTypes.delete, color: 'red' })
    btns.push({ caption: 'Cancel', oc: handle_showConfirmation, icon: appIconTypes.delete, color: iconColorTypes.remove, fl: true })
    return <UiSaveButtons others={btns} />
  }

  const header = () => {
    let caption = ''
    switch (_dataModifyType) {
      case dataModificationTypes.add:
        caption = 'Add New Item (' + _.startCase(uivi) + ')'
        break;
      case dataModificationTypes.edit:
        caption = selectedName + ': ' + selectedEditItemKey
        break;
      default:
        caption = selectedName + ': ' + selectedEditItemKey
        break;
    }
    return <div className='header-flex-right'>
      <div><Icon name='arrow left' color={'blue'} onClick={(e) => { handleBack() }} /></div>
      <div>{caption}</div>
    </div >
  }

  const wrapper_confirmation = () => {
    switch (showConfirmation) {
      case _optionsTypes.linkData:
        return <DataLinkingSidebar />
      default:
        return <Wrapper
          header={'Confirmation'}
          content={'Are you sure you want to ' + _.startCase(showConfirmation) + '?'}
          footer={footer_confirmation()}
          wrapperType={wrapperTypes.padded}
        />
    }
  }

  const wrapper_modify = () => <Wrapper
    header={handleBack && header()}
    content={modifyProps && modifyData ? <DataItemModifyForm
      modifyHandlers={modifyHandlers()}
      modifyProps={modifyProps}
      modifyData={modifyData}
      modifyViewItem={currentViewItem}
    /> : <div></div>}
    footer={footer_modify()}
    wrapperType={wrapperTypes.padded}
    css={{ container: 'app-dark-mode' }}
    updating={updating}
  />

  return showConfirmation ? wrapper_confirmation() : wrapper_modify()
}

export default ItemModifySidebar